import api from './api';
import type { 
  Administration, 
  AdministrationFormData, 
  AdministrationStatistics, 
  ApiResponse 
} from '../../types/administration.types';

class AdministrationService {
  private readonly endpoint = '/api/administration';

  async getAll(officeType?: string): Promise<ApiResponse<Administration[]>> {
    const params = officeType ? { type: officeType } : {};
    const response = await api.get<ApiResponse<Administration[]>>(this.endpoint, { params });
    return response.data;
  }

  async getSecretariatOfficers(): Promise<ApiResponse<Administration[]>> {
    const response = await api.get<ApiResponse<Administration[]>>(`${this.endpoint}/secretariat`);
    return response.data;
  }

  async getHeadOfficeOfficers(): Promise<ApiResponse<Administration[]>> {
    const response = await api.get<ApiResponse<Administration[]>>(`${this.endpoint}/head-office`);
    return response.data;
  }

  async getStatistics(): Promise<ApiResponse<AdministrationStatistics>> {
    const response = await api.get<ApiResponse<AdministrationStatistics>>(`${this.endpoint}/statistics`);
    return response.data;
  }

  async getById(id: number): Promise<ApiResponse<Administration>> {
    const response = await api.get<ApiResponse<Administration>>(`${this.endpoint}/${id}`);
    return response.data;
  }

  async create(officerData: AdministrationFormData): Promise<ApiResponse<Administration>> {
    const response = await api.post<ApiResponse<Administration>>(this.endpoint, officerData);
    return response.data;
  }

  async update(id: number, officerData: Partial<AdministrationFormData>): Promise<ApiResponse<Administration>> {
    const response = await api.put<ApiResponse<Administration>>(`${this.endpoint}/${id}`, officerData);
    return response.data;
  }

  async delete(id: number): Promise<ApiResponse<void>> {
    const response = await api.delete<ApiResponse<void>>(`${this.endpoint}/${id}`);
    return response.data;
  }

  async toggleStatus(id: number): Promise<ApiResponse<Administration>> {
    const response = await api.put<ApiResponse<Administration>>(`${this.endpoint}/${id}/toggle-status`);
    return response.data;
  }
}

export const administrationService = new AdministrationService();
